type RiskLevel = 'on_track' | 'at_risk' | 'stalled';

interface RiskIndicatorProps {
  level: RiskLevel;
}

const config: Record<RiskLevel, {label: string; dot: string; badge: string}> = {
  on_track: {
    label: 'On Track',
    dot: 'bg-emerald-500',
    badge: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  },
  at_risk: {
    label: 'At Risk',
    dot: 'bg-amber-500',
    badge: 'text-amber-700 bg-amber-50 border-amber-200',
  },
  stalled: {
    label: 'Stalled',
    dot: 'bg-red-500 animate-pulse',
    badge: 'text-red-700 bg-red-50 border-red-200',
  },
};

export function RiskIndicator({level}: RiskIndicatorProps) {
  const {label, dot, badge} = config[level];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${badge}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
}
